import { type FC, useCallback } from "react";
import { useParams } from "react-router-dom";

import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { useLensSubmissionRoutesV3 } from "../../core/routes/hooks";

import { CreateOrganizationAndLensSpacePageContainer } from "./CreateOrganizationAndLensSpacePage";

export const LensSubmissionCreateOrganizationAndLensSpace: FC = () => {
    const { goToLensFolderSelect } = useLensSubmissionRoutesV3();
    const { submissionId = "" } = useParams<RouteParams[AbsoluteRoute.SUBMIT]>();

    const onCreationSuccess = useCallback(() => {
        goToLensFolderSelect(submissionId);
    }, [goToLensFolderSelect, submissionId]);

    return <CreateOrganizationAndLensSpacePageContainer onCreationSuccess={onCreationSuccess} />;
};
